import { Box, CircularProgress, Container, Grid, Modal, Paper, styled, Table, TableBody, TableCell, tableCellClasses, TableContainer, TableHead, TableRow } from '@mui/material';
import React, { Component } from 'react'
import Constantes from '../php/Constantes';


const StyledTableCell = styled (TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
      backgroundColor: theme.palette.common.black,
      color: theme.palette.common.white,
    },
    [`&.${tableCellClasses.body}`]: {
      fontSize: 14,
    },
}));
  
const StyledTableRow = styled(TableRow)(({ theme }) => ({
    '&:nth-of-type(odd)': {
        backgroundColor: theme.palette.action.hover,
    },
    // hide last border
    '&:last-child td, &:last-child th': {
        border: 0,
    },
}));

const Item = styled(Paper)(({ theme }) => ({
    backgroundColor: theme.palette.mode === 'dark' ? '#1A2027' : '#F4F6F6',
    ...theme.typography.body2,
    padding: theme.spacing(1),
    textAlign: 'center',
    color: theme.palette.text.secondary,
}));

const styleModal = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 500,
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    p: 4,
};

class AgregarSuspendida extends Component {
    constructor(props){
        super(props);
        this.state = {
            numeroNombre: [],
            loading: false,
            notificaciones: null,
            errores: null,
            consulta: false,
            datosConsulta: [],
            busqueda: {
                numeroFuncionario: '',
            },
            licenciaSuspendida: {
                numeroFuncionario: '',
                nombreFuncionario: '',
                dias: '',
                ejercicio: '',
            },
            movEditar: {},
            modalBorrar: false,
        }

        this.manejoEnvioNumeroFuncionario = this.manejoEnvioNumeroFuncionario.bind(this);
        this.manejarCambioNumFun = this.manejarCambioNumFun.bind(this);
        this.manejarCambiosDatos = this.manejarCambiosDatos.bind(this);
        this.manejarEnvioLicencia = this.manejarEnvioLicencia.bind(this);
        this.manejarAtras = this.manejarAtras.bind(this);
        this.manejarEnvioBorrar = this.manejarEnvioBorrar.bind(this);
        this.cerrarModal = this.cerrarModal.bind(this);
        this.manejarEnvioBaja = this.manejarEnvioBaja.bind(this);
    }

    async componentDidMount(){
        const numNom = await fetch(`${Constantes.RUTA_API}/obtener_numerosNombre.php`);
        const datosNumNom = await numNom.json();
        this.setState({
            numeroNombre: datosNumNom,
        });
    }
    render(){
        return (
            <>
                <Container>
                    <h3 style={{textAlign: 'center'}}>Licencias Suspendidas</h3>
                    {this.state.loading
                    ?
                        <div style={{placeItems: 'center'}}>
                            <Box sx={{alignItems: 'center'}}>
                                <CircularProgress/>
                            </Box>
                        </div>
                    :
                        null
                    }
                    {this.state.notificaciones ? (<div className="alert alert-success" > {this.state.notificaciones}</div>) : null}
                    {this.state.errores ? (<div className='alert alert-danger'> {this.state.errores}</div>) : null}
                    {this.state.consulta
                    ?
                        null
                    :
                        <Container>
                            <form className='formulario1'  onSubmit={this.manejoEnvioNumeroFuncionario}>
                                <Box sx={{ flexGrow: 1}} >
                                    <Grid container spacing={2} rowSpacing={1}>
                                        <Grid item xs={3}>
                                        </Grid>
                                        <Grid item xs={3}>
                                            <Item>Número de Funcionario</Item>
                                        </Grid>
                                        <Grid item xs={2}>
                                            <input style={{border: "2px solid #D6EAF8", width: "100%"}} id='numeroFuncionario' value={this.state.busqueda.numeroFuncionario} onChange={this.manejarCambioNumFun} type="number" />
                                        </Grid>
                                        <Grid item xs={1}>
                                            <button className="btn btn-outline-primary mx-2" type='submit'>Buscar</button>
                                        </Grid>
                                    </Grid>
                                </Box>
                            </form>
                            <TableContainer style={{width: '100%', marginLeft:'auto', marginRight:'auto'}} component={Paper}>
                                <Table sx={{minWidth: 700}}>
                                    <TableHead>
                                        <TableRow>
                                            <StyledTableCell>Número Funcionario</StyledTableCell>
                                            <StyledTableCell>Nombre Funcionario</StyledTableCell>
                                            <StyledTableCell>Días</StyledTableCell>
                                            <StyledTableCell>Ejercicio</StyledTableCell>
                                            <StyledTableCell></StyledTableCell>
                                        </TableRow>
                                    </TableHead>
                                        <TableBody>
                                            <StyledTableRow>
                                                <StyledTableCell><input style={{width:"100%", border:"2px solid #D6EAF8"}} type="number" id='numeroFuncionario' value={this.state.licenciaSuspendida.numeroFuncionario} onChange={this.manejarCambiosDatos}/></StyledTableCell>
                                                <StyledTableCell>{this.state.licenciaSuspendida.nombreFuncionario}</StyledTableCell>
                                                <StyledTableCell><input style={{width:"100%", border:"2px solid #D6EAF8"}} type="number" id='dias' value={this.state.licenciaSuspendida.dias} onChange={this.manejarCambiosDatos}/></StyledTableCell>
                                                <StyledTableCell><input style={{width:"100%", border:"2px solid #D6EAF8"}} type="number" id='ejercicio' value={this.state.licenciaSuspendida.ejercicio} onChange={this.manejarCambiosDatos}/></StyledTableCell>
                                                <StyledTableCell><button className="btn btn-outline-primary mx-2" type='button' onClick={this.manejarEnvioLicencia}>Agregar</button></StyledTableCell>
                                            </StyledTableRow>
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </Container>
                    }
                    {this.state.consulta
                    ?
                        <Container>
                            <TableContainer style={{width: '100%', marginLeft:'auto', marginRight:'auto'}} component={Paper}>
                                <Table sx={{minWidth: 700}} id="tablaConsulta">
                                    <TableHead>
                                        <TableRow>
                                            <StyledTableCell>Número Funcionario </StyledTableCell>
                                            <StyledTableCell>Nombre Funcionario</StyledTableCell>
                                            <StyledTableCell>Días</StyledTableCell>
                                            <StyledTableCell>Ejercicio</StyledTableCell>
                                            <StyledTableCell></StyledTableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {this.state.datosConsulta.map((dato) => (
                                            <StyledTableRow key={dato.idLicenciasSuspendidas}>
                                                <StyledTableCell>{dato.numeroFuncionario}</StyledTableCell>
                                                <StyledTableCell>{dato.nombreFuncionario}</StyledTableCell>
                                                <StyledTableCell>{dato.totalDias}</StyledTableCell>
                                                <StyledTableCell>{dato.ejercicio}</StyledTableCell>
                                                <StyledTableCell><button className="btn btn-outline-danger mx-2" type='button' onClick={() => this.manejarEnvioBorrar(dato)}>Borrar</button></StyledTableCell>
                                            </StyledTableRow>
                                        ))}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                            <button className="btn btn-outline-primary mx-2" style={{marginTop: '1rem'}} type='button' onClick={this.manejarAtras}>Volver</button>
                        </Container>
                    :
                        null
                    }
                    <Modal open={this.state.modalBorrar}>
                        <form className='formulario1'>
                            <Box sx={styleModal} >
                            <h3 style={{textAlign:'center'}}>¿Confirmar Baja Licencia Suspendida?</h3>
                                <Grid container spacing={2} rowSpacing={1}>
                                    <Grid item xs={2}>

                                    </Grid>
                                    <Grid item xs={4}>
                                        <button className="btn btn-outline-primary mx-2" style={{marginTop:'2rem'}} type='button' onClick={this.manejarEnvioBaja}>Confirmar</button>
                                    </Grid>
                                    <Grid item xs={4}>
                                        <button className="btn btn-outline-danger mx-2" style={{marginTop:'2rem'}} type='button' onClick={this.cerrarModal}>Cancelar</button>
                                    </Grid>
                                </Grid>
                            </Box>
                        </form>
                    </Modal>
                </Container>
            </>
        )
    }

    async manejoEnvioNumeroFuncionario(e){
        e.preventDefault();
        this.setState({
            errores: null,
            notificaciones: null,
            loading: true,
        });

        const cargaUtil = JSON.stringify([this.state.busqueda]);

        const respuesta = await fetch(`${Constantes.RUTA_API}/obtener_licenciasSuspendidas.php`,{
            method: 'POST',
            body: cargaUtil,
        })
        const exito = await respuesta.json();
        this.setState({
            loading: false,
            notificaciones: null,
            errores: exito[0],
        })
        if(exito){
            if(exito[0] === 'ok'){

                this.setState({
                    consulta: true,
                    datosConsulta: exito[1],
                    errores: null,
                })
            }
        }
    }

    manejarCambioNumFun(e){
        e.preventDefault();
        const clave = e.target.id;
        let valor = e.target.value;
        this.setState(state => {
            const numFunActualizado = state.busqueda;
            numFunActualizado[clave] = valor;
            return{
                busqueda: numFunActualizado,
            };
        });
    }

    manejarCambiosDatos(e){
        e.preventDefault();
        this.setState({
            notificaciones: null,
            errores: null,
        });
        const clave = e.target.id;
        let valor = e.target.value;
        
        this.setState(state => {
            const movimientosActualizado = state.licenciaSuspendida;
            if(clave === 'numeroFuncionario'){
                //valor = parseFloat(valor);
                //Tengo que buscar la informacion de ese funcionario
                let aux = true;
                this.state.numeroNombre.map((name) =>
                {if(name.numeroFuncionario === valor){
                    movimientosActualizado['nombreFuncionario'] = name.primerNombre + ' ' + name.primerApellido;
                    aux = false;
                }else if(aux){
                    movimientosActualizado['nombreFuncionario'] = '';
                }
                });
            }
            movimientosActualizado[clave] = valor;
            return{
                licenciaSuspendida: movimientosActualizado,
            };
        })
    }

    async manejarEnvioLicencia(e){
        e.preventDefault();

        this.setState({
            errores: null,
            notificaciones: null,
            loading: true,
        });

        const cargaUtil = JSON.stringify([sessionStorage.numeroFuncionarioAsociado, this.state.licenciaSuspendida]);

        const respuesta = await fetch(`${Constantes.RUTA_API}/guardar_licenciaSuspendida.php`,{
            method: 'POST',
            body: cargaUtil,
        })
        const exito = await respuesta.json();
        this.setState({
            loading: false,
            notificaciones: null,
            errores: exito[0],
        })
        if(exito){
            if(exito[0] === 'ok'){

                this.setState({
                    consulta: false,
                    errores: null,
                    notificaciones: 'Los datos fueron ingresados correctamente.',
                })
            }
        }
    }

    manejarAtras(e){
        e.preventDefault();
        this.setState({
            errores: null,
            notificaciones: null,
            consulta: false,
            datosConsulta: [],
            busqueda: {
                numeroFuncionario: '',
            },
        })
    }

    async manejarEnvioBorrar(dato){
        this.setState({
            modalBorrar: true,
            movEditar: dato,
            notificaciones: null,
        });
    }

    cerrarModal(e){
        e.preventDefault();
        this.setState({
            movEditar: {},
            modalBorrar: false,
        });
    }

    async manejarEnvioBaja(e){
        e.preventDefault();
        const cargaUtil = JSON.stringify([sessionStorage.numeroFuncionarioAsociado, this.state.movEditar]);

        const respuesta = await fetch(`${Constantes.RUTA_API}/borrar_licenciaSuspendida.php`,{
            method: 'POST',
            body: cargaUtil,
        })
        const exito = await respuesta.json();
        if(exito){
            let contador = 0;
            const arr = this.state.datosConsulta;
            arr.map((name) => {
                if(this.state.movEditar.idLicenciasSuspendidas === name.idLicenciasSuspendidas){
                    arr.splice(contador, 1);
                }else{
                    contador++;
                }
            });
            this.setState({
                notificaciones: 'Los datos fueron borrados correctamente',
                modalBorrar: false,
                datosConsulta: arr,
            });
        }
    }
}

export default AgregarSuspendida